import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import { OrderService } from "../shared/order.service";

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.scss']
})
export class OrderDetailsComponent implements OnInit {

  data: Object;
  load: Subscription = new Subscription();
  isRecla: Boolean = true;

  /**
   * @param route 
   */
  constructor(
    private route: ActivatedRoute,
    private orderService: OrderService
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.isRecla = params['isRecla'] == 'true';
    });
    this.getDetails();
    window.scrollTo(0, 0)
  }

  ngOnDestroy() {
    this.load.unsubscribe();
  }

  getDetails() {
    this.load = this.route.data.subscribe(data => {
      this.data = data.order;
    })
  }

  export(value) {
    if (this.isRecla) {
      this.load = this.orderService.exportReclamation(value).subscribe();
    } else {
      this.load = this.orderService.export(value).subscribe();
    }
  }

  downloadFile(fileMime, fileName) {
    if (this.isRecla) {
      this.orderService.getReclamationPj(this.data, fileName, fileMime).subscribe(fileData => {
        const link = document.createElement("a")
        link.href = "data:" + fileMime + ";base64," + fileData
        link.download = fileName
        link.click()
        link.remove()
      });
    } else {
      this.orderService.getDemandePj(this.data, fileName, fileMime).subscribe(fileData => {
        const link = document.createElement("a")
        link.href = "data:" + fileMime + ";base64," + fileData
        link.download = fileName
        link.click()
        link.remove()
      });
    }

  }

  downloadFile1() {
    this.downloadFile(this.data['file_mime1'], this.data['file_name1'])
  }

  downloadFile2() {
    this.downloadFile(this.data['file_mime2'], this.data['file_name2'])
  }

  downloadFile3() {
    this.downloadFile(this.data['file_mime3'], this.data['file_name3'])
  }

  canHaveReponse() {
    return this.data['type'] != "Gestion au quotidien" || this.data['titre'] == "Demande de diminution de stock" || this.data['titre'] == "Demande d'augmentation de stock"
  }
}
